import 'rxjs/add/observable/from';
import 'rxjs/add/observable/empty';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/mergeMap';
import { Observable } from 'rxjs/Observable';
import {
	CARD_AUTO_SCROLL_REQUEST_ON_FILTER,
	cardAutoScroll,
} from '../../state/actions/cards/auto-scroll/index.tsx';
import { getLastSelectedCard } from '../../state/selectors/cards/index.tsx';
import type { Action, ActionsObservable, MiddlewareAPI } from '../../state/types.tsx';

export const cardAutoScrollOnFilterEpic = (action$: ActionsObservable, store: MiddlewareAPI) =>
	action$.ofType(CARD_AUTO_SCROLL_REQUEST_ON_FILTER).mergeMap(() => {
		const state = store.getState();
		const selectedIssueId = getLastSelectedCard(state);
		return selectedIssueId
			? Observable.of(cardAutoScroll(selectedIssueId))
			: Observable.empty<Action>();
	});
